import React, {useState, useMemo} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useWebsite } from '../../Data/Website';
import { PageLoading } from '../../Components/Loading';
import Form, { Actions, Conditional, Switch, TextField } from '../../Components/Form';
import Alert from '../../Components/Alert';
import CopyableValue from '../../Components/Formatting/CopyableValue';

const ThirdPartySettings = () => {
    const {website, changeDomain, isSaving} = useWebsite(true);

    return <>
        <TopBar left="/more" title="Domain & Pages" />
        <Page>
            {website ? <Inner {...{website, changeDomain, isSaving}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({website, changeDomain, isSaving}) => {

    const [domain, setDomain] = useState(website.domain);
    const domainPrefix = useMemo(() => {
        if (domain && domain.length > 8) {
            return '...' + (domain.slice(-8).replace(/^[^\w\s]/g, ''))+'/';
        }
        return domain;
    }, [domain])

    const websiteData = {
        ...website,
        quotesPage: website.quotesPage ? website.quotesPage.replace(/^\//, '') : null,
        paymentsPage: website.paymentsPage ? website.paymentsPage.replace(/^\//, '') : null,
        portalPage: website.portalPage ? website.portalPage.replace(/^\//, '') : null,
    };

    if (website.type !== 'thirdparty') {
        return <Alert theme="error" title="Not available" message="This page is only applicable to third party websites." />
    }

    return <>
        <div className="prose prose-sm mb-4">
            <p>You can add the getSoapy Quote, Payment and Customer Portal widgets on any page of your website. You'll need your business ID to connect the widgets to your account.</p>

            <CopyableValue title="Business ID" value={website.businessId} />

            <p>So we can send customers direct links to the right place, let us know which page these are on.</p>

            <p>If you don't want to add them all to your website, you can chose to have each of them on a getSoapy.com page instead.</p>
        </div>

        <Form data={websiteData} onSubmit={changeDomain}>
            <TextField name="domain" label="Website domain" prefix="https://" onChange={setDomain} />

            <h3 className="mt-4 font-bold">Quote widget</h3>

            <Switch name="useHostedQuotePage" label="Use on getSoapy.com" />
            <Conditional condition={d => !d.useHostedQuotePage}>
                <TextField name="quotesPage" label="Page with quote widget" prefix={domainPrefix} />
            </Conditional>

            <h3 className="mt-4 font-bold">Quote widget</h3>

            <Switch name="useHostedPaymentsPage" label="Use on getSoapy.com" />
            <Conditional condition={d => !d.useHostedPaymentsPage}>
                <TextField name="paymentsPage" label="Page with payments widget" prefix={domainPrefix} />
            </Conditional>

            <h3 className="mt-4 font-bold">Customer Portal widget</h3>

            <Switch name="useHostedPortalPage" label="Use on getSoapy.com" />
            <Conditional condition={d => !d.useHostedPortalPage}>
                <TextField name="portalPage" label="Page with portal widget" prefix={domainPrefix} />
            </Conditional>

            <Actions submit={{label: 'Save'}} />
        </Form>
    </>
}

export default ThirdPartySettings;
